import React from 'react'
import Pt from 'prop-types'
import cx from 'classnames'

import { PaymentTokenRecord } from '../../records'

export default function PaymentTokenDetails({
  token,
}) {
  return (
    <div className={cx('payment-token', { 'text-danger': token.failures > 0 })}>
      <strong>{token.card.number}</strong><br />
      <small className="text-muted">
        {token.card.name}
      </small>
    </div>
  )
}

PaymentTokenDetails.propTypes = {
  token: Pt.instanceOf(PaymentTokenRecord).isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Payment/TokenDetails.jsx